export class ScoreTypeMapping {
    public id: number;
    public metricId: string;
    public name: string;

    constructor(id: number, metricId: string, name: string) {
        this.id = id;
        this.metricId = metricId;
        this.name = name;
    }
}

export default class ScoreTypes {
    public static scoreTypeMappings: ScoreTypeMapping[] = [
        new ScoreTypeMapping(1, '0a6e5c48-3f1d-43e9-b948-4fd1bf57d624', 'Tries'),
        new ScoreTypeMapping(2, '78d99913-b227-48ce-8883-5de65b0d2d05', 'Penalty Tries'),
        new ScoreTypeMapping(3, 'e698326f-49c9-41e6-ab69-7fe008c72ccc', 'Penalty Goal Kicks'),
        new ScoreTypeMapping(4, '9922b23d-e7e4-4bf9-828d-0e3aba06f685', 'Drop Goals'),
        new ScoreTypeMapping(5, '7f6a760b-e6fd-4272-a93c-5f8ee03b88d9', 'Conversions'),
        new ScoreTypeMapping(6, '9814c571-6d87-4b4a-8bbb-8ac27cdeb97f', 'Appearances'),
        new ScoreTypeMapping(7, '1d0d9674-e0cb-4189-8c2f-b67ddc969186', 'StandardTries'),
        new ScoreTypeMapping(8, '642513a7-2c63-4a22-98b2-3312b2cafeb6', 'TriesFrom22m'),
        new ScoreTypeMapping(9, '9861d8c0-4a5e-4371-ad1d-7c830ac2f218', 'TriesFrom22mToHalf'),
        new ScoreTypeMapping(10, 'fa6b5563-40b1-4630-b0c8-0ea403867074', 'TriesFromOwnHalf'),
        new ScoreTypeMapping(11, 'e5566365-5216-470b-9280-8c72db7ee3f0', 'TriesFromPowerPlay'),
        new ScoreTypeMapping(12, 'e5566365-5216-470b-9280-8c72db7ee3f0', 'SevenPointTries')
    ];

    static getScoreType(id: number): ScoreTypeMapping {
        return this.scoreTypeMappings.find(scoreTypeMapping => scoreTypeMapping.id == id);
    }
}